import type { SystemSettings } from "./types";

export const DEFAULT_RETENTION_AUDIT_INTERVAL_HOURS = 24;
export const MAX_RETENTION_AUDIT_INTERVAL_HOURS = 168;

export function isValidRetentionAuditInterval(value: unknown): value is number {
	return (
		typeof value === "number" &&
		Number.isInteger(value) &&
		value >= 1 &&
		value <= MAX_RETENTION_AUDIT_INTERVAL_HOURS
	);
}

export function resolveRetentionAuditSchedule(
	settings?: Pick<SystemSettings, "retentionAudit"> | null,
) {
	const configured = settings?.retentionAudit;
	const valid =
		configured?.intervalHours === undefined ||
		isValidRetentionAuditInterval(configured.intervalHours);
	return {
		scheduledEnabled: configured?.scheduledEnabled === true && valid,
		intervalHours: isValidRetentionAuditInterval(configured?.intervalHours)
			? configured.intervalHours
			: DEFAULT_RETENTION_AUDIT_INTERVAL_HOURS,
	};
}
